import { FlowNodeTypeValue } from './types';
import { getNodeInfo, getTypesByCategory, CATEGORY_LABELS, NodeInfo } from './metadata';

export function Palette() {
  const categories: NodeInfo['category'][] = ['trigger', 'action', 'branching', 'terminal'];

  return (
    <aside className="wt-rf-palette">
      {categories.map((cat) => (
        <section key={cat} className="wt-rf-palette-section">
          <h4 className="wt-rf-palette-title">{CATEGORY_LABELS[cat]}</h4>
          {getTypesByCategory(cat).map((type) => (
            <PaletteItem key={type} type={type} />
          ))}
        </section>
      ))}
    </aside>
  );
}

function PaletteItem({ type }: { type: FlowNodeTypeValue }) {
  const info = getNodeInfo(type);

  const onDragStart = (e: React.DragEvent) => {
    e.dataTransfer.setData('application/wisertalk-node', String(type));
    e.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      className="wt-rf-palette-item"
      draggable
      onDragStart={onDragStart}
      style={{ borderColor: info.color }}
    >
      <span className="wt-rf-node-dot" style={{ background: info.color }} />
      <span>{info.label}</span>
    </div>
  );
}
